import { createSlice } from '@reduxjs/toolkit';

const promoSelectModeSlice = createSlice({
    name: 'promoSelectMode',
    initialState: {
        isSelectingPromoType: false,
    },
    reducers: {
        setSelectingPromoType: (state, action) => {
            state.isSelectingPromoType = action.payload;
        },
        toggleSelectingPromoType: (state) => {
            state.isSelectingPromoType = !state.isSelectingPromoType;
        },
    },
});

export const { setSelectingPromoType, toggleSelectingPromoType } = promoSelectModeSlice.actions;
export default promoSelectModeSlice.reducer;
